module.exports = __webpack_public_path__ + "img/new-seash.8723d2d2.svg";